export default function disableBodyScroll() {
  document.body.style.overflow = 'hidden';
}
